import type {TAPIElementFieldNames} from '@/assets/core/assets/api/types';
import type {IWebhookUpdate} from '@/api/types/webhook';

import {webhookAPI} from '@/api/requesters/webhook';

const fieldNames: TAPIElementFieldNames<IWebhookUpdate> = {
  pageTitle: 'Вебхуки',
  drawerTitle: 'Вебхук',

  name: 'Название',
  url: 'Ссылка',
  is_active: 'Активен',
  headers: 'Заголовки',
};

const useWebhookControllerHook = () => {
  const api = webhookAPI.clone();

  const validate = (form?: IWebhookUpdate) => {
    return !!form?.name && !!form?.url;
  };

  return {
    ...api,
    fieldNames,

    validate,
  };
};

const webhookController = useWebhookControllerHook();

export default webhookController;
